import { AnyObject } from "@/types";
import React from "react";

export function labelToId(label: string = ""): string {
  return label.toLowerCase().replace(" ", "-");
}

export function isObject(item: unknown): item is object {
  return item !== null && typeof item === "object" && !Array.isArray(item);
}

export function merge(target: AnyObject, ...sources: AnyObject[]): AnyObject {
  sources.forEach((source) => {
    Object.keys(source).forEach((key) => {
      if (isObject(source[key]) && isObject(target[key])) {
        target[key] = merge(target[key], source[key]);
      } else {
        target[key] = source[key];
      }
    });
  });
  return target;
}

export const resolveSlotProps = (fn: unknown, args: unknown) =>
  typeof fn === "function" ? fn(args) : fn;

export function hasHTMLTags(str: string) {
  const regex = /<[^>]+>/g;
  return regex.test(str);
}

// Extract items from Option children if present (supporting mixed children, fragments, etc)
export function flattenChildren(
  children: React.ReactNode
): React.ReactElement[] {
  const result: React.ReactElement[] = [];
  React.Children.forEach(children, (child) => {
    if (!child) return;
    if (Array.isArray(child)) {
      result.push(...flattenChildren(child));
    } else if (
      (child as any).type &&
      ((child as any).type.displayName === "Option" ||
        (child as any).type.name === "Option" ||
        (child as any).type.displayName === "Tab" ||
        (child as any).type.name === "Tab")
    ) {
      result.push(child as React.ReactElement);
    } else if ((child as any).props && (child as any).props.children) {
      // Handle fragments or nested children
      result.push(...flattenChildren((child as any).props.children));
    }
  });
  return result;
}
